import React from 'react'

const GlowButton = ({ text, clickHandler, isOpen }) => {
  return (
    <button
      onClick={clickHandler}
      className="bg-white flex justify-between lg:justify-center items-center lg:w-fit w-full px-6 md:px-8 py-2 lg:py-2 text-black text-center text-lg md:text-xl lg:text-2xl font-medium rounded-full border-2 border-white whitespace-nowrap shadow-[0_0_20px_4px_rgba(255,255,255,0.8)] z-10 hover:scale-105 transition-all duration-700 cursor-pointer"
    >
      {text}

      <div className='md:hidden w-5 h-5'>
        <img
          className={`w-5 h-5 transform transition-transform duration-300 tint ${isOpen ? 'rotate-180' : ""}`}
          src='/assets/services/3/angle-down-black.png'
          alt='angle-down'
        />
      </div>
    </button>
  )
}

export default GlowButton